import { getToken, _fetch } from "./apiHelper";
import { protectedResources } from "../config/authConfig";
import { Project } from "../types/project";

export const getProjects = async () => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.project, options);
};

export const getProjectsByWorkspaceId = async (workspaceId : string) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.project + `/${workspaceId}`, options);
};

export const postProject = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(protectedResources.api.project, options);
};

export const editProject = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(protectedResources.api.project, options);
};

export const addPostMeasurementDate = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/postMeasurementDate`, options);
};

export const endPrep = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/endPrep`, options);
};

export const startMeasurement = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/start`, options);
};

export const stopMeasurement = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/stop`, options);
};

export const startIntPlanning = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(
    `${protectedResources.api.project}/start-int-planning`,
    options
  );
};
export const endIntPlanning = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/end-int-planning`, options);
};
export const editIntPlanning = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/edit-int-planning`, options);
};

export const endImplementation = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(
    `${protectedResources.api.project}/end-implementation`,
    options
  );
};

export const endPostMeasurementPrep = async (project : Project) => {
  const accessToken = await getToken();
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "PUT",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(project),
  };

  return _fetch(`${protectedResources.api.project}/end-post-prep`, options);
};

export const getUserProjectHubList = async (projectCode : string, controller : AbortController) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal: controller.signal as AbortSignal,
  };

  return _fetch(
    `${protectedResources.api.project}/user-project-hub-list/${projectCode}`,
    options
  );
};

export const createAppUsers = async (projectCode : string, users: number, controller : AbortController) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
    signal: controller.signal as AbortSignal,
  };

  return _fetch(
    `${protectedResources.api.project}/create-app-users/${projectCode}/${users}`,
    options
  );
};
